
import i18n from "@/plugins/i18n";
import { TranslateResult } from "vue-i18n";
import { Prop, Watch } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import Component, { mixins } from "vue-class-component";
import { ActionMixin } from "../mixins/ActionMixin";
import { TokenService } from "@/api/storage";
import Hashids from "hashids";
import UserPost from "@/modules/timeline/components/UserPost.vue";
type sidebar_items = {
  name: string | TranslateResult;
  route: string;
  svgIcon: string;
};
@Component({
  components: {
    UserPost,
  },
})
export default class TheSidebar extends mixins(ActionMixin) {
  @Prop({ default: false }) toggle: boolean;
  @Prop(Boolean) isNotification: boolean;
  @Prop(Boolean) isMessageNotification: boolean;
  selected = null;
  currentIndex = 0;
  generalItemsClevel = [
    {
      name: "Timeline",
      route: "timelineHome",
      svgIcon: "timeline",
    },
    {
      name: i18n.t("community.myCommunities"),
      route: "profileCommunity",
      svgIcon: "exclusive_lounge",
    },
    {
      name: "Debates",
      route: "roundTableList",
      svgIcon: "chat",
    },
    {
      name: i18n.t("readingList.papers"),
      route: "readingListWhitePaperList",
      svgIcon: "news",
    },
    {
      name: i18n.t("readingList.successCase"),
      route: "readingListSuccessCase",
      svgIcon: "lamp",
    },
    {
      name: i18n.t("favorite.favorite"),
      route: "favoritesHome",
      svgIcon: "favorite_lead",
    },
    {
      name: i18n.t("readingList.readingList"),
      route: "readingListItems",
      svgIcon: "flag",
    },
    {
      name: "Exclusive Club",
      route: "exclusiveClub",
      svgIcon: "club",
    },
    {
      name: i18n.t("profile.messages"),
      route: "chatHome",
      svgIcon: "e-mail",
    },
    {
      name: i18n.t("notification.title"),
      route: "notificationHome",
      svgIcon: "notification_off",
    },
  ];
  generalItemsExecutive = [
    {
      name: "Timeline",
      route: "timelineHome",
      svgIcon: "timeline",
    },
    {
      name: i18n.t("community.myCommunities"),
      route: "profileCommunity",
      svgIcon: "exclusive_lounge",
    },
    {
      name: i18n.t("readingList.papers"),
      route: "readingListWhitePaperList",
      svgIcon: "news",
    },
    {
      name: i18n.t("readingList.successCase"),
      route: "readingListSuccessCase",
      svgIcon: "lamp",
    },
    {
      name: "Leads",
      route: "leadsHome",
      svgIcon: "favorite_lead",
    },
    {
      name: i18n.t("readingList.readingListExecutive"),
      route: "readingListItems",
      svgIcon: "flag",
    },
    {
      name: i18n.t("profile.messages"),
      route: "chatHome",
      svgIcon: "e-mail",
    },
    {
      name: i18n.t("notification.title"),
      route: "notificationHome",
      svgIcon: "notification_off",
    },
  ];
  generalItemsPartner = [
    {
      name: "Timeline",
      route: "timelineHome",
      svgIcon: "timeline",
    },
    {
      name: i18n.t("community.myCommunities"),
      route: "profileCommunity",
      svgIcon: "exclusive_lounge",
    },
    {
      name: "Debates",
      route: "roundTableList",
      svgIcon: "chat",
    },
    {
      name: i18n.t("readingList.papers"),
      route: "readingListWhitePaperList",
      svgIcon: "news",
    },
    {
      name: i18n.t("readingList.successCase"),
      route: "readingListSuccessCase",
      svgIcon: "lamp",
    },
    {
      name: i18n.t("favorite.favorite"),
      route: "favoritesHome",
      svgIcon: "favorite_lead",
    },
    {
      name: i18n.t("readingList.readingList"),
      route: "readingListItems",
      svgIcon: "flag",
    },
    {
      name: i18n.t("profile.messages"),
      route: "chatHome",
      svgIcon: "e-mail",
    },
    {
      name: i18n.t("notification.title"),
      route: "notificationHome",
      svgIcon: "notification_off",
    },
  ];
  generalItemsEquipe = [
    {
      name: "Timeline",
      route: "timelineHome",
      svgIcon: "timeline",
    },
    {
      name: i18n.t("community.myCommunities"),
      route: "profileCommunity",
      svgIcon: "exclusive_lounge",
    },
    {
      name: i18n.t("readingList.papers"),
      route: "readingListWhitePaperList",
      svgIcon: "news",
    },
    {
      name: i18n.t("readingList.successCase"),
      route: "readingListSuccessCase",
      svgIcon: "lamp",
    },
    {
      name: i18n.t("readingList.readingList"),
      route: "readingListItems",
      svgIcon: "flag",
    },
    {
      name: i18n.t("profile.messages"),
      route: "chatHome",
      svgIcon: "e-mail",
    },
    {
      name: i18n.t("notification.title"),
      route: "notificationHome",
      svgIcon: "notification_off",
    },
  ];
  logoutItem = {
    name: i18n.t("sidebar.logout"),
    route: "loginPage",
    svgIcon: "exit",
  };
  changeUserItem = {
    name: i18n.t("sidebar.changeUser"),
    route: "changeUser",
    svgIcon: "refresh",
  };
  transparencyItem = {
    name: i18n.t("transparency.sidebar"),
    route: "transparency",
    svgIcon: "policy_sidebar",
  };
  drawer = true;
  filter = "";
  mini = false;
  TokenService = TokenService;
  urls: any = {
    development: "https://admin-dev.exclusivelounge.network",
    staging: "https://admin-staging.exclusivelounge.network",
    production: "https://admin.exclusivelounge.network",
  };
  @State("currentFilter") currentFilter: any;
  @State((state) => state.profile.me) me: any;
  @State((state) => state.timeline.bannerImages) bannerImages: any;
  @Action("updateFilter") updateFilter: any;
  @Action("profile/requestUpdateTheme") requestUpdateTheme: any;
  @Action("onboarding/requestLogout") requestLogout: any;
  @Action("updateRouteAfterLogin") updateRouteAfterLogin: any;
  @Action("updateFilterInput") updateFilterInput: any;
  @Action("updateMiniSidebarValue") updateMiniSidebarValue: any;
  @Action("updateCurrentTabFourNetwork") updateCurrentTabFourNetwork: any;
  get classButton(): string {
    return this.$vuetify.breakpoint.mdAndDown ? "button-mobile-responsive" : "";
  }
  get currentUser(): any {
    return this.me;
  }
  get classMiniSidebar(): string {
    return this.mini ? "px-1" : "px-2";
  }
  get generalItems(): sidebar_items[] {
    return TokenService.getRole() === "EQUIPE"
      ? this.generalItemsEquipe
      : TokenService.getRole() === "PARTNER"
      ? this.generalItemsPartner
      : TokenService.getRole() === "EXECUTIVE"
      ? this.generalItemsExecutive
      : this.generalItemsClevel;
  }
  get colorBackground(): string {
    return this.$vuetify.breakpoint.mdAndDown
      ? "purple100"
      : !this.mini
      ? "white"
      : "purple100 disabled-button-gray";
  }
  get arrowColor(): string {
    return this.$route.name === "profileHome" ||
      this.$vuetify.breakpoint.mdAndDown
      ? "white"
      : "purple100";
  }
  created(): void {
    // this.drawer = this.$vuetify.breakpoint.mdAndUp;
    this.filter = this.currentFilter;
  }
  mounted(): void {
    let currentItem: any;
    this.generalItems.forEach((item: sidebar_items) => {
      let route = this.$route.name;
      if (route?.includes(item.route)) currentItem = item;
    });
    this.selected =
      this.transparencyItem.route === this.$route.name
        ? this.transparencyItem
        : currentItem;
  }
  updateMiniSidebar(): void {
    this.mini = !this.mini;
  }
  isSeletecItem(item: sidebar_items): boolean {
    return this.selected === item;
  }
  async updateSelectedItem(item: any): Promise<void> {
    if (item.route === "changeUser") {
      const hashids = new Hashids();
      const encode = hashids.encode(this.me.userPortalId);
      const { VUE_APP_MODE } = process.env;
      const url = `${this.urls[VUE_APP_MODE]}/onboarding/${encode}/${this.$root.$i18n.locale}`;
      window.open(url, "_blank");
    } else {
      const newRoute = this.selected === item ? null : item;
      if (newRoute?.route === "loginPage") {
        this.updateRouteAfterLogin({ name: "", params: {} });
        await this.requestLogout();
      }
      if (newRoute) this.$router.push({ name: newRoute.route });
    }
  }
  backgroundSelectedItem(item: sidebar_items): string {
    return this.$vuetify.breakpoint.mdAndDown
      ? this.isSeletecItem(item)
        ? `gray70--text ${this.colorBackground}`
        : `white--text ${this.colorBackground}`
      : this.isSeletecItem(item)
      ? `purple100--text ${this.colorBackground}`
      : `gray70--text ${this.colorBackground}`;
  }
  async updateTheme(item: boolean): Promise<void> {
    const payload = {
      theme: item ? "DARK" : "LIGHT",
    };
    await this.withLoading(async () => {
      await this.requestUpdateTheme(payload);
    });
  }
  redirectSearch(): void {
    if (this.$route.name !== "searchHome")
      this.$router.push({ name: "searchHome" });
  }
  redirectProfile(): void {
    if (this.$route.name !== "profileHome")
      this.$router.push({ name: "profileHome" });
  }
  redirectProfileFourNetwork(key: number): void {
    if (this.$route.name !== "timelineFourNetworkSection")
      this.$router.push({
        name: "timelineFourNetworkSection",
      });
    this.updateCurrentTabFourNetwork(key);
  }
  updateStoreFilter(): void {
    if (!this.filter) return;
    this.updateFilter(!this.filter ? "" : this.filter);
    if (
      this.$vuetify.breakpoint.mdAndDown &&
      this.$route.name === "searchHome"
    ) {
      this.drawer = false;
    }
    this.redirectSearch();
  }
  clearStoreFilter(): void {
    this.filter = "";
    this.updateFilter(!this.filter ? "" : this.filter);
    this.redirectSearch();
  }
  miniSidebar(): void {
    this.mini = !this.mini;
  }
  @Watch("mini") onMiniChanged(): void {
    this.updateMiniSidebarValue(this.mini);
  }
  @Watch("toggle", { immediate: true }) onItemChanged(): void {
    if (this.$vuetify.breakpoint.lgAndDown) this.drawer = this.toggle;
  }
  @Watch("filter", { immediate: true, deep: true })
  updateValueFilter(): void {
    this.updateFilterInput(!this.filter ? "" : this.filter);
  }
  @Watch("$vuetify.breakpoint.lgAndUp") onBreakpointChanged(
    newVal: boolean
  ): void {
    // Quando a tela ficar menor que lg, resetar mini para false e fechar drawer
    if (!newVal) {
      if (this.mini) {
        this.mini = false;
      }
      // Fechar drawer para evitar overlay quando redimensiona de lg para md/menor
      this.drawer = false;
    }
  }
}
